var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFigureyoga(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 24.5625 26.0508",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    height: 26.0508,
    opacity: 0,
    width: 24.5625,
    x: 0,
    y: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4648 5.12109C17.8828 5.12109 19.0078 3.98438 19.0078 2.55469C19.0078 1.13672 17.8828 0 16.4648 0C15.0352 0 13.8867 1.13672 13.8867 2.55469C13.8867 3.98438 15.0352 5.12109 16.4648 5.12109ZM8.48438 26.0391C9.14062 26.0391 9.70312 25.5 9.70312 24.832L9.70312 13.8281C12.375 13.3945 14.6953 11.625 15.8086 9.21094C15.9023 8.96484 16.1836 8.84766 16.6523 9.01172L22.582 11.0039C23.4023 11.2734 23.9648 10.8281 24.1406 10.2539C24.3281 9.66797 24.1172 8.95312 23.3555 8.70703L5.58984 2.77734C4.76953 2.49609 4.19531 2.95312 4.01953 3.52734C3.83203 4.11328 4.05469 4.81641 4.81641 5.07422L11.2031 7.20703C11.4961 7.3125 11.6484 7.66406 11.4609 7.96875C10.7812 9.03516 9.77344 9.67969 8.48438 9.67969L2.42578 9.67969L2.42578 3.59766C2.42578 2.88281 1.94531 2.39062 1.20703 2.39062C0.480469 2.39062 0 2.88281 0 3.59766L0 10.793C0 11.5898 0.398438 11.9648 1.00781 12.0703L6.375 12.9609L7.27734 18.2578L7.27734 24.832C7.27734 25.5 7.81641 26.0391 8.48438 26.0391Z",
    fill: "currentColor",
    fillOpacity: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFigureyoga);
export default __webpack_public_path__ + "static/media/figure.yoga.690fca13cecec0eba645207ad16324f7.svg";
export { ForwardRef as ReactComponent };